var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-3/4 md:max-w-1/2 py-2 px-4 inline text-md bg-gray-300",class:[
    _vm.isRequest
      ? 'bg-green-400 self-end text-right text-white rounded-t-3xl rounded-bl-3xl'
      : 'bg-purple-300 self-start text-gray-800 rounded-b-3xl rounded-tr-3xl' ],staticStyle:{"border":"solid 1px #AAAAAA"},style:([
  _vm.isRequest
    ? 'background-color:#D67FFF'
    : '' ])},[(_vm.isRequest)?_c('p',{staticClass:"whitespace-pre-wrap p-3",staticStyle:{"cursor":"pointer"},domProps:{"innerHTML":_vm._s(_vm.part.value)},on:{"click":function($event){return _vm.copyAnswer(_vm.part.value)}}}):_c('p',{staticClass:"whitespace-pre-wrap p-3",domProps:{"innerHTML":_vm._s(_vm.part.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }